import { Fragment, useState } from 'react'

import classNames from 'classnames'

import { ProfileDefaultImage } from '@local/assets/images'

import Image from '@web/components/Image'
import useMe from '@web/hooks/useMe'
import { useRegistToSequentialList } from '@web/libs/sequential'

import styles from './LotteryReceiptReviewMissionCardContent.module.scss'
import BoardAnimation from '../../MissionStamp/BoardAnimation'
import MissionRollingCountAnimation from '../../MissionStamp/MissionRollingCountAnimation'
import ParticleAnimation from '../../MissionStamp/ParticleAnimation'

interface Props {
  stampCounts: number
  withAnimation?: boolean
  animationOrder?: number
  isSummary?: boolean
}

const DISPLAY_STEPS = 7
const DISPLAY_PREV_STEPS = 3
const ROLLING_DURATION = 1

const LotteryReceiptReviewMissionCardContent = ({
  stampCounts,
  withAnimation = false,
  animationOrder = 1,
  isSummary,
}: Props) => {
  const { me } = useMe()

  const [move, setMove] = useState(false)

  useRegistToSequentialList({
    order: animationOrder,
    onExecute: () => setMove(true),
    type: 'withPrev',
    delaySeconds: 0,
    durationSeconds: 1.2,
    id: `lottery-step-${animationOrder}`,
  })

  const [rolling, setRolling] = useState(false)

  useRegistToSequentialList({
    order: animationOrder,
    onExecute: () => setRolling(true),
    type: 'withPrev',
    delaySeconds: 0,
    durationSeconds: ROLLING_DURATION,
    id: `lottery-rolling-${animationOrder}`,
  })

  const shouldMove = isSummary ? (withAnimation ? move : true) : false

  return (
    <div
      className={classNames(styles.review_lottery_progress_area, {
        [styles.type_exist_review]: !!stampCounts,
        [styles.type_modal]: isSummary,
      })}
    >
      {isSummary && <BoardAnimation order={animationOrder} isEnd={!withAnimation} />}
      {Array(DISPLAY_STEPS)
        .fill(null)
        .map((_, index) => {
          const position = index + (isSummary ? -1 : 0)
          const diff = position - DISPLAY_PREV_STEPS
          const stepNumber = stampCounts + diff
          const isDisplayableStepNumber = stepNumber > 0
          const isCurrent = stampCounts === stepNumber

          return (
            <Fragment key={stepNumber}>
              {isDisplayableStepNumber && (
                <div
                  key={stepNumber}
                  className={classNames(styles.count, styles[`type_position_${position + 1}`], {
                    [styles.type_over100]: stepNumber >= 100,
                    [styles.type_over1000]: stepNumber >= 1000,
                    [styles.apply_animation]: shouldMove,
                  })}
                >
                  <div className={styles.count_inner}>
                    <span className={styles.num}>{stepNumber}</span>
                  </div>
                </div>
              )}
              {isCurrent && (
                <div className={classNames(styles.profile_thumb_area, { [styles.apply_animation]: shouldMove })}>
                  <div className={classNames(styles.thumb_area, { [styles.apply_animation]: shouldMove })}>
                    <Image src={me?.profile?.imageUrl ?? ProfileDefaultImage} width="100%" height="100%" alt="프로필" />
                  </div>
                  <div className={classNames(styles.ly_count, { [styles.apply_animation]: withAnimation })}>
                    내 리뷰{' '}
                    {withAnimation ? (
                      <MissionRollingCountAnimation
                        finalNumber={stepNumber}
                        rolling={rolling}
                        height={18}
                        durationSeconds={ROLLING_DURATION}
                        rollingCount={10}
                        insetShadow
                      />
                    ) : (
                      stepNumber
                    )}
                    개{withAnimation && <ParticleAnimation order={animationOrder} className={styles.particle} />}
                  </div>
                </div>
              )}
            </Fragment>
          )
        })}
    </div>
  )
}

export default LotteryReceiptReviewMissionCardContent
